import { RatingPassThroughOptions } from 'primereact/rating'
import { classNames } from 'primereact/utils'

export const ratingConfig: RatingPassThroughOptions = {
  root: ({ props }) => ({
    className: classNames('mk-rating', {
      'mk-rating--disabled': props.disabled,
    }),
  }),
  cancelitem: ({ context }) => ({
    className: classNames('mk-rating__cancel-item', {
      'mk-rating__cancel-item--focused': context.focused,
    }),
  }),
  cancelicon: {
    className: 'mk-rating__cancel-icon',
  },
  item: ({ props, context }) => ({
    className: classNames(
      'mk-rating__item',
      {
        'mk-rating__item--readonly': props.readOnly,
      },
      {
        'mk-rating__item--focused': context.focused,
      },
    ),
  }),
  officon: {
    className: 'mk-rating__off-icon',
  },
  onicon: {
    className: 'mk-rating__on-icon',
  },
}
